import React from 'react';
import {Form,Input,Radio,Button} from 'antd';
import UpPhoto from './Model/UpPhoto';
import cbhead from "../assets/images/cbhead.jpg";
import Axios from 'axios';
import {Redirect}from 'react-router-dom';

class NewVideo extends React.Component{
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      //视频封面链接
      let url;
      if(this.state.parentText===""||this.state.parentText===undefined||this.state.parentText===null){
        url=localStorage.getItem("photo");
      }else{
        url =this.state.parentText;
      } 
      //区域id
      let regionId = this.state.regionId;
      //区域名字
      let regionName =this.state.regionName;
       //县域id
       let countyId = this.state.countyId;
       //县名字
       let countyName =this.state.countyName;
      //视频名字
      let videoName =values.videoName;
      //跳转链接
      let videoUrl =values.videoUrl;
      //s视频标签
      let vLable = values.vLable;
      //村宝ID
      let cbId = localStorage.getItem("cbId");
      //视频ID
      let id = localStorage.getItem("id");
       //登录人ID
       let userId = localStorage.getItem("userId");
       //开始时间.format("YYYY-MM-DD HH:mm:ss");
   //    let startTime= Moment(values.startTime.valueOf()).format("YYYY-MM-DD HH:mm:ss");
      if(url===""||url===undefined||url===null){
        alert("封面不能为空")
        return;   
      }
      //Axios 请求 提交村宝信息到后台接口POST /switch/video/save
      let api =this.state.domain+"/switch/video/save";
      var  params = new URLSearchParams();
      params.append("videoUrl",url);//封面链接
      params.append("cityId",regionId);//区ID
      params.append("cityName",regionName);//区名字
      params.append("countyId",countyId);//县ID
      params.append("countyName",countyName);//县名字
      params.append("name",videoName);//视频名字
      params.append("videoLink",videoUrl);//跳转链接
      params.append("videoType","1");//0 PK；1 发现；3 直播
      params.append("type","0");//：0 视频；1 轮播图片
      params.append("tag",vLable);//视频标签
     // params.append("startTime",startTime);//开始时间
      params.append("treasureId",cbId);//村宝id
      if(!(id===""||id===undefined||id===null)){
        params.append("id",id);//视频id
      }
      params.append("adminId",userId);//登录人ID
      Axios.post(api,params)
      .then((res)=>{
         if(res.data.status===1){
          alert("提交成功")
          //保存完成跳转列表
          this.setState({
            saveFlag:true
          })
          return;     
         }else{
           console.log(res.data.message);
           alert("提交失败")
           return;     
         }
      })
     .catch((error)=>{
         alert("提交失败")
         return;
     }) 
    });
  };

      normFile = e => {
        if (Array.isArray(e)) {
          return e;
        }
        return e && e.fileList;
      };
      state={
        regionName:"",
        regionId:"",
        countyId:"",
        countyName:"",
        vLable:"",
        parentText:"",
        videoUrl:"",
        videoName:"",
        name:"",
        cbId:"",
        id:"",
        startTime:"",
        //domain:'http://10.0.7.102:3005',
        domain:"",
        saveFlag:false
     }
       //组件将要挂载时候加载的生命周期函数
    componentWillMount(){
      //村宝id
      let cbId = localStorage.getItem("cbId");
      let regionId = localStorage.getItem("regionId");
      let regionName = localStorage.getItem("regionName");
      let countyId = localStorage.getItem("countyId");
      let countyName = localStorage.getItem("countyName");
      let cbName = localStorage.getItem("cbName");
      //视频名字
      let videoName= localStorage.getItem("videoName")?localStorage.getItem("videoName"):"";
     //视频链接
     let videoUrl =localStorage.getItem("videoUrl")?localStorage.getItem("videoUrl"):"";
    //开始时间
     // let startTime =  localStorage.getItem("startTime")?localStorage.getItem("startTime"):"";
      //视频ID
      let id = localStorage.getItem("id")?localStorage.getItem("id"):"";
      //视频标签
      let vLable = localStorage.getItem("vLable")?localStorage.getItem("vLable"):"非遗";
      //如果村宝用户id 不用空初始化 state 信息
      //aixo 请求
      this.setState({
        cbId:cbId,//村宝ID
        regionName:regionName,
        regionId:regionId,
        cbName:cbName,//村宝名字
        vLable:vLable,//默认
        countyId:countyId,
        countyName:countyName,
        videoName:videoName,
        videoUrl:videoUrl,
        //startTime:startTime,
        id:id
      })
    }
      fn(data) {
        this.setState({
            parentText: data //把父组件中的parentText替换为子组件传递的值
        },() =>{
           console.log(this.state.parentText);//setState是异步操作，但是我们可以在它的回调函数里面进行操作
        });
    
    }
    fh=()=>{
      this.setState({
        saveFlag:true //把父组件中的parentText替换为子组件传递的值
      })
    }
      render(){ 
        const { getFieldDecorator } = this.props.form;
        if(this.state.saveFlag){
          return <Redirect to={{pathname: `/news/videoList/${this.state.cbId}`} }/>;
        };
        return(
            <div>  
            <img style={{width:'100%'}} src={cbhead} alt="视频头部"/>  
           <Form  onSubmit={this.handleSubmit}>
           <Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="村宝名字">
          <span className="ant-form-text">{this.state.cbName}</span>
           </Form.Item>
           <Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="地市标签">
              <span className="ant-form-text">{this.state.countyName}</span>
          </Form.Item>
           <Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="视频名字:">
              {getFieldDecorator('videoName', {
                initialValue:this.state.videoName,
                rules: [
                  {
                    required: true,
                    message: '请输入视频名字',
                  },
                ],
              })(<Input placeholder="请输入视频名字" />)}
            </Form.Item>
            <Form.Item labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="视频封面:" >
            {getFieldDecorator('vi',{
                initialValue:"视频封面",
                rules: [
                  {
                    required: true,
                  },
                ],
              })(<UpPhoto pfn={this.fn.bind(this)}/>)}            
             </Form.Item>
             <Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 10 }} label="视频链接:">
              {getFieldDecorator('videoUrl', {
                initialValue:this.state.videoUrl,
                rules: [
                  {
                    required: true,
                    message: '请输入视频链接地址',
                  },
                ],
              })(<Input placeholder="请输入视频链接地址" />)}
            </Form.Item>
           {/**<Form.Item  labelCol={{ span: 6 }} wrapperCol={{ span: 3 }} label="视频开始时间">
              {getFieldDecorator('startTime',  {
               initialValue: this.state.startTime?Moment(this.state.startTime, 'YYYY-MM-DD HH:mm:ss'):null,
               rules: [{ required: true, message: "请输入视频开始时间" }],
             })(
                <DatePicker showTime format="YYYY-MM-DD HH:mm:ss" />,
              )} 
           </Form.Item>*/} 
            <Form.Item   labelCol={{ span: 6 }} wrapperCol={{ span: 10 }} label="视频标签">
              {getFieldDecorator('vLable', {
                initialValue:this.state.vLable,
                rules: [
                  {
                    required: true,               
                  },
                ],
              })(
                <Radio.Group>
                  <Radio.Button value="非遗">非遗</Radio.Button>　
                  <Radio.Button value="戏曲">戏曲</Radio.Button>　
                  <Radio.Button value="舞蹈/歌曲">舞蹈/歌曲</Radio.Button>　
                  <Radio.Button value="相声/小品">相声/小品</Radio.Button>　
                  <Radio.Button value="民俗">民俗</Radio.Button>　
                  <Radio.Button value="音乐">音乐</Radio.Button>　
                  <Radio.Button value="美术/书法">美术/书法</Radio.Button>
                </Radio.Group>,
              )}
            </Form.Item>
            <Form.Item wrapperCol={{ span: 12, offset: 8 }}>
            {localStorage.getItem("regionId")==="0"?"":
              (<Button type="primary" htmlType="submit">
                提交信息
             </Button>)}
              　　<Button  type="primary"  onClick={()=>{this.fh()}}>
                视频列表
              </Button>
            </Form.Item>
          </Form>
              </div>
        )
      }
    }
    const WrappedVideoNew = Form.create({ name: 'validate_other' })(NewVideo);
    export default WrappedVideoNew;


// WEBPACK FOOTER //
// ./src/components/NewVideo.js